import { useState, useEffect } from 'react';
import butterflyApi from '../ButterflyApi.js';
import FileUpload from "../Utils/FileUpload";
import Utils from "../utils";

const StoryItem = ({ item, onUpdate }) => {
  const [content, setContent] = useState('')

  useEffect(() => {
    if (!item) return
    setContent(item.content)
  }, [item])

  const saveContent = async () => {
    if (!item) return
    if (!content) return
    await butterflyApi.updateStory(item.heroStoryNo, content)
    onUpdate()
  }

  const onImageUpload = async (fileInfo) => {
    const url = fileInfo.operationUrls?.[0]?.replace("http://", "https://") || fileInfo.url.replace("http://", "https://")
    await butterflyApi.updateStoryImage(item.heroNo, item.scriptNo, item.pageNo, url)
    await new Promise(resolve => setTimeout(resolve, 5000))
    onUpdate()
  }

  return <div className='mt-8 border rounded-lg p-4'>
    <div className='flex justify-between items-center mb-2'>
      <div className='font-bold'>페이지 {item.pageNo}</div>
      <div className='text-sm text-gray-500'>Verified : {item.verifiedDatetime}</div>
    </div>
    <div className='w-64'>
      <img src={item.imageUrl} alt="" />
    </div>
    <div className='mt-2'>
      <FileUpload path={`/public/images/gpt`}
        filename={Utils.uuidv4()}
        uploaded={async (fileinfo) => { await onImageUpload(fileinfo) }}
        onlyImage={true}
        maxSize={10000000}
        overSizeMessage="10MB 이하의 이미지만 업로드 가능합니다."
      >
        <button className="text-sm bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded">
          이미지 변경
        </button>
      </FileUpload>
    </div>
    <div className='mt-4'>
      <textarea className='w-full text-sm border rounded p-2' rows={8}
        value={content} onChange={e => setContent(e.target.value)} />
      <button className='mt-1 text-sm bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600' onClick={saveContent}>
        저장
      </button>
    </div>
  </div>
}

const StoryManage = () => {
  const queryParams = new URLSearchParams(window.location.search)
  const heroNo = queryParams.get("heroNo")
  const scriptNo = queryParams.get("scriptNo")

  const [items, setItems] = useState([])
  const [title, setTitle] = useState('')
  const [imagePrompt, setImagePrompt] = useState('')
  const [storyContent, setStoryContent] = useState('')
  const [reviewedContent, setReviewedContent] = useState('')
  const [hero, setHero] = useState()
  const [botTasks, setBotTasks] = useState([])

  const load = async () => {
    if (!heroNo || !scriptNo) return
    const tasks = await butterflyApi.getTasks(heroNo)
    if (tasks && tasks.length > 0) {
      const storyItems = tasks.filter(t => t.scriptNo == scriptNo)
      storyItems.sort((a, b) => a.pageNo - b.pageNo)
      setItems(storyItems)
      if (storyItems.length > 0) {
        setTitle(storyItems[0].title || '')
      }
    }
    const summary = await butterflyApi.getSummary()
    const heroItem = summary?.heroes?.find(h => h.heroNo == heroNo)
    setHero(heroItem)
    const storiesRes = await butterflyApi.getStories(scriptNo, heroNo)
    setStoryContent(`
아래 동화 내용 검토해서 내용을 수정해줘

## 동화 내용
${storiesRes?.content || ''}

## 수정 시 참고 사항
* 동화를 읽는 대상은 유치원생
* 동화 내용은 바꾸지 말고, 너무 어렵지 않은 단어나 문장 구조 사용하도록 수정.
* ---로 페이지를 나눠 놓았는데, 그 구조를 그대로 유지해서 "---"로 페이지를 나누어줘.
* 어떤 부분을 변경되었는지도 설명해줘
* 수정본을 코드블록 안에 넣어서 그대로 복사할 수 있게 줘.
* 수정된 내용을 복사할때는 동화 내용만 복사할수 있게 불필요한 안내 문구 같은건 제외해줘.
* --- 앞뒤로 줄 간격을 벌리기 위한 줄바꿈은 없어 돼.
`)
    const botTasksRes = await butterflyApi.getBotTasks(scriptNo, heroNo)
    setBotTasks(botTasksRes || [])
    const response = await butterflyApi.getImagePrompt(heroNo, scriptNo)
    setImagePrompt(`
동화의 삽화로 사용할 이미지를 만들어줘
아이들이 좋아할 만한 재미있는 그림이었으면 좋겠어.
주인공 모습과 동화 내용은 아래에 있어.
그럼, 주인공 모습과 동화 내용을 참고해서 각 페이지에 사용할 이미지를 만들어줘.

${response}

## 기타 참고 사항
* 지브리 스튜디오 스타일
* 모든 페이지에 문자나 글자, 알파벳을 포함한 모든 텍스트가 노출되지 않도록 해줘. (특히 말풍선, 간판 같은 곳에 글자가 포함되지 않도록 해줘)
* 영역 분할 없이 페이지별 중요한 이미지 하나만
* 이미지 사이즈는 1024x1024
* 각 페이지에 등장하는 등장인물들은 입고 있는 의상이 페이지별로 다르지 않고 유지되어야 함.

---

1~5페이지 이미지를 각각 페이지별로 한개씩, 총 5개의 이미지를 만들어줘.
`)
  }

  useEffect(() => {
    load()
  }, [heroNo, scriptNo])

  if (!heroNo || !scriptNo) {
    return <div className="px-4 mt-12">heroNo와 scriptNo 파라미터가 필요합니다.</div>
  }

  return <div className="px-4 mt-12 max-w-2xl">
    <div className="mb-4 flex gap-4">
      <a href="/manage" className="text-blue-600 underline">Manage</a>
      <a href="/manage/heroes" className="text-blue-600 underline">Heroes</a>
      <a href={`/manage/hero?heroNo=${heroNo}`} className="text-blue-600 underline">Hero</a>
      <a href={`/manage/script?scriptNo=${scriptNo}&heroNo=${heroNo}`} className="text-blue-600 underline">Script</a>
    </div>

    <div className="flex items-center gap-3 mb-2">
      <div className="text-lg font-bold">{title}</div>
      <button className="text-sm bg-orange-500 text-white px-3 py-1 rounded hover:bg-orange-600"
        onClick={async () => {
          await butterflyApi.boostTasks(scriptNo, heroNo)
          alert('부스트 요청되었습니다.')
          load()
        }}>
        부스트
      </button>
      <button className="text-sm bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
        onClick={async () => {
          if (!window.confirm('이미지생성 태스크를 생성하시겠습니까?')) return
          await butterflyApi.createTask(heroNo, scriptNo, 'IMAGE_GENERATION')
          alert('이미지생성 태스크가 생성되었습니다.')
          load()
        }}>
        이미지생성
      </button>
      <button className="text-sm bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
        onClick={async () => {
          if (!window.confirm('동화검토 태스크를 생성하시겠습니까?')) return
          await butterflyApi.createTask(heroNo, scriptNo, 'STORY_REVIEW')
          alert('동화검토 태스크가 생성되었습니다.')
          load()
        }}>
        동화검토
      </button>
      <button className="text-sm bg-purple-500 text-white px-3 py-1 rounded hover:bg-purple-600"
        onClick={async () => {
          if (!window.confirm('동화를 생성하시겠습니까?')) return
          await butterflyApi.getScriptPrompt(scriptNo, true, heroNo)
          alert('동화 생성이 완료되었습니다.')
          window.location.href = `/manage?heroNo=${heroNo}&scriptNo=${scriptNo}`
        }}>
        동화생성
      </button>
    </div>
    <div className='text-sm text-gray-500 mb-2'>
      heroNo: {heroNo} / scriptNo: {scriptNo}
    </div>

    {botTasks.length > 0 && <div className="mb-4 border rounded p-3 bg-gray-50">
      <div className="font-bold text-sm mb-2">Bot Tasks</div>
      <div className="space-y-2">
        {botTasks.map(task => (
          <div key={task.taskNo} className="text-xs border rounded p-2 bg-white space-y-1">
            <div className="flex gap-3 items-center">
              <span className="font-medium">{task.taskType}</span>
              {task.pageNo != null && <span className="text-gray-500">p.{task.pageNo}</span>}
              <span className={task.done ? 'text-green-600' : 'text-yellow-600'}>{task.done ? '완료' : '진행중'}</span>
              {task.holding && <span className="text-red-500">홀딩</span>}
              <button className="ml-auto text-red-500 hover:text-red-700"
                onClick={async () => {
                  if (!window.confirm(`${task.taskType} 태스크를 삭제하시겠습니까?`)) return
                  await butterflyApi.deleteTask(scriptNo, heroNo, task.taskType)
                  load()
                }}>
                삭제
              </button>
            </div>
            <div className="text-gray-500">등록: {task.registerDatetime}</div>
            {task.doneDatetime && <div className="text-gray-500">완료: {task.doneDatetime}</div>}
            {task.aiTaskUrl && <div><a href={task.aiTaskUrl} target="_blank" rel="noreferrer" className="text-blue-600 underline break-all">{task.aiTaskUrl}</a></div>}
            {task.comment && <div className="text-gray-700">comment: {task.comment}</div>}
            {task.checkContent && <div className="text-gray-700 whitespace-pre-wrap">checkContent: {task.checkContent}</div>}
          </div>
        ))}
      </div>
    </div>}

    {hero && <div className="mb-4">
      <div className="font-bold text-sm mb-1">주인공</div>
      <img src={hero.graphicImageUrl} className="w-24 h-24 object-cover rounded" alt="" />
    </div>}

    <div className="mb-4">
      <div className="font-bold text-sm mb-1">Image Prompt</div>
      <textarea value={imagePrompt} className='w-full text-xs border rounded p-2' rows={6} readOnly />
      <button className="mt-1 text-sm bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded"
        onClick={() => navigator.clipboard.writeText(imagePrompt.replace(/\n\s*\n/g, '\n\u00A0\n'))}>
        복사
      </button>
    </div>

    {storyContent && <div className="mb-4">
      <div className="font-bold text-sm mb-1">동화 검토 Prompt</div>
      <textarea value={storyContent} className='w-full text-xs border rounded p-2' rows={6} readOnly />
      <button className="mt-1 text-sm bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded"
        onClick={() => navigator.clipboard.writeText(storyContent)}>
        복사
      </button>
    </div>}

    <div className="mb-4">
      <div className="font-bold text-sm mb-1">검토 완료 동화 반영</div>
      <textarea className='w-full text-xs border rounded p-2' rows={6}
        value={reviewedContent} onChange={e => setReviewedContent(e.target.value)}
        placeholder="검토 완료된 동화 내용을 입력하세요" />
      <button className="mt-1 text-sm bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
        onClick={async () => {
          if (!reviewedContent) return
          if (!window.confirm('검토 완료된 내용을 반영하시겠습니까?')) return
          await butterflyApi.updateStories(scriptNo, heroNo, reviewedContent)
          alert('반영되었습니다.')
          load()
        }}>
        반영
      </button>
    </div>

    {items.length === 0 && <div className="text-gray-500">로딩중...</div>}

    {items.map(item => (
      <StoryItem key={item.heroStoryNo} item={item} onUpdate={load} />
    ))}
  </div>
}

export default StoryManage
